module.exports = __webpack_public_path__ + "c977d3626579b36ad0c766542582fc2b.webp";